$(".image-with-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplaySpeed: 3000,
  speed: 1000,
  arrows: true,
  dots: true,
  autoplay: true,
  pauseOnHover:false,
  responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(".mutli_usp_listing_product").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,
  autoplaySpeed: 3000,
  speed: 1000,
  arrows: true,
  dots: false,
  autoplay: true,
  pauseOnHover:false,
  responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(document).ready(function(){
  $(".video-close-buton").click(function(){
   $('#pop-video').get(0).pause();
   $('#pop-video').get(0).currentTime = 0; 
   $("#video-popup").hide();
  });
});


$(document).scroll(function () {
    var cutoff = $(window).scrollTop();
    $('.faq-listing-rwo .common-section-header').each(function () {
        if ($(this).offset().top + $(this).height() > cutoff) {
            //$('.faqsectionpernt').removeClass('current');
            //$(this).addClass('current');
          
            var currSection = $(this).attr('id');          

            $('.catlink a').removeClass('active');
            $('.catlink a[data-id=' + currSection + ']').addClass('active');

            return false;

        }
    });
});


//window.addEventListener('DOMContentLoaded',(event)=>{
//document.querySelectorAll('facet-filters-form details.facets__disclosure-vertical').forEach(item=>{
//if(!item.hasAttribute('open')){
//item.querySelector('summary').click()
//}
//})
//});



$(function () {
  $(".reloadCheckbox").change(function () {
    var item = $(this);
    if (item.is(":checked")) {
      var dataUrl = this.getAttribute('data-url');
      window.location.href = dataUrl;
    } else{
      window.location.href = "/blogs/technical-resources/"
    }
  });
});

$(".right-buttons .get_quote").click(function(){  
  $(".header-popup-modal").attr("open", "open"); 
});

if ($(window).width() > 749) {
$('.list-menu__item.facets__item label.facet-checkbox').on("click",function(){
      //$(window).scrollTop(0);    
setTimeout(function() {
   $('html, body').animate({
        scrollTop: $('#MainContent').offset().top + 300 
    });
 }, 500);  
});
} 




  $(document).ready(function() {
    $('a[href^="http"]').not('[href*="' + window.location.hostname + '"]').attr('target', '_blank');
  });



